import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";
import * as i18n from "../common/i18n";
import MaterialTable from 'material-table'
import { reactLocalStorage } from 'reactjs-localstorage';

import gql from 'graphql-tag';
import Message from "./Message";
import ConfigurationWizard from "./ConfigurationWizard"

import * as graphql from '../common/graphql';
import * as helper from "../common/helper";
import moment from "moment";
import Chip from '@material-ui/core/Chip';
import RouterIcon from '@material-ui/icons/Router';
import ReloadIcon from '@material-ui/icons/Replay';
import TuneIcon from '@material-ui/icons/Tune';


import { withIAM, isInRoles, ROLE_ADMIN, ROLE_READER, ROLE_OWNER, ROLE_ASSISTANT, ROLE_EDITOR } from "../common/iam";

const styles = theme => ({
});

const defaults = {
    id: true,
    device: false,
    version: false,
    endpoints: true,
    freq: false,
    mlMax: false,
    mlMin: false,
    mmMax: false,
    msLog: false,
    msMax: false,
    msMin: false,
    ringBuffer: false,
    sWait: false,
    sHeartbeat: false,
    threshold: false,
    created: true,
    pageSize: 20,
};

const defaultsPropertyName = 'p71.configurations.defaults';

class Configurations extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            wizard: false,
            message: null,
            details: null,
            hideAfter: 3000,
            variant: "info",
            userSettings: reactLocalStorage.getObject(defaultsPropertyName, defaults),
        };

        this.tableRef = React.createRef();
    }

    default(id) {
        return this.state.userSettings[id] !== undefined ? this.state.userSettings[id] : defaults[id];
    }

    setDefault(id, value) {

        const newUserSettings = { ...this.state.userSettings };
        newUserSettings[id] = value;

        this.setState({ userSettings: newUserSettings }, () => {
            reactLocalStorage.setObject(defaultsPropertyName, newUserSettings);
        });
    }

    showMessage = (message, variant, details, hideAfter) => {
        this.setState({
            message: message,
            variant: variant ? variant : "info",
            hideAfter: hideAfter ? hideAfter : 3000,
            details: details ? details : null,
        })
    }

    closeMessage = () => {
        this.setState({
            message: null,
            details: null,
            hideAfter: 3000,
            variant: "info",
        })
    }

    mapField(column) {
        switch (column) {
            case "device":
                return "uuid"
            default:
                return column;
        }
    }

    getInput = (data) => {
        try {

            const input = {}

            helper.set(input, data, "id");
            helper.set(input, data, "uuid");
            helper.set(input, data, "created");
            helper.set(input, data, "version");
            helper.set(input, data, "sWait");
            helper.set(input, data, "mlMax");
            helper.set(input, data, "mlMin");
            helper.set(input, data, "mmMax");
            helper.set(input, data, "msMin");
            helper.set(input, data, "msMax");
            helper.set(input, data, "msLog");
            helper.set(input, data, "freq");
            helper.set(input, data, "threshold");
            helper.set(input, data, "ringBuffer");
            helper.set(input, data, "endpoints");
            helper.set(input, data, "sHeartbeat");
            
            if (!input["sHeartbeat"]) input["sHeartbeat"] = 0;

            return input;

        } catch (error) {
            throw new Error(i18n.get("configurations.error.validation"))
        }
    }

    handleWizardCancel = () => {
        this.setState({ wizard: false, working: false })
    }

    handleWizardSave = (newData) => {
        this.setState({ wizard: false, working: false });
        new Promise(async (resolve, reject) => {
            try {

                const input = this.getInput(newData)
                const result = await graphql.clientWithToken(this.props.accessToken).mutate({
                    variables: {
                        "input": input
                    },
                    mutation: gql`
                    mutation addConfiguration($input: ConfigurationInput!) {
                        addConfiguration(input: $input) {
                            id
                        }

                    }
                `,
                });

                this.showMessage(i18n.get("configurations.message.onAdd.success"), "success")
                this.tableRef.current.onQueryChange();
                resolve();
            } catch (error) {
                this.showMessage(i18n.get("configurations.message.onAdd.error"), "error", error.message);
                reject(error);
            }
        })
    }

    render() {
        return (
            <div style={{ maxWidth: '100%' }}>
                <MaterialTable
                    components={{
                        Cell: helper.defaultCell,
                        FilterRow: helper.defaultFilter
                    }}
                    icons={helper.tableIcons}
                    onChangeRowsPerPage={pageSize => { this.setDefault("pageSize", pageSize) }}
                    onChangeColumnHidden={data => { this.setDefault(data["field"], data["hidden"]) }}
                    tableRef={this.tableRef}
                    localization={i18n.getLocalization()}
                    columns={[
                        {
                            title: i18n.get("configurations.id"),
                            field: 'id',
                            hidden: this.default("id"),
                            cellStyle: {
                                minWidth: '200px',
                                maxWidth: '200px',
                            },
                            headerStyle: {
                                minWidth: '200px',
                                maxWidth: '200px',
                            },
                            sorting: true,
                            filtering: true
                        },
                        {
                            title: i18n.get("configurations.device"),
                            field: 'device',
                            hidden: this.default("device"),
                            cellStyle: {
                                minWidth: '100px',
                                maxWidth: '100px',
                            },
                            headerStyle: {
                                minWidth: '100px',
                                maxWidth: '100px',
                            },
                            sorting: true,
                            filtering: true,
                            render: rowData => {
                                return rowData && rowData.device ? <Chip label={rowData.device.uuid} icon={<RouterIcon />} /> : null
                            }
                        },
                        {
                            title: i18n.get("configurations.version"),
                            field: 'version',
                            hidden: this.default("version"),
                            cellStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            headerStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            filterComponent: helper.RangeFilter,
                            type: "numeric",
                            sorting: true,
                            filtering: true
                        },

                        {
                            title: i18n.get("configurations.mlMax"),
                            field: 'mlMax',
                            hidden: this.default("mlMax"),
                            cellStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            headerStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            filterComponent: helper.RangeFilter,
                            type: "numeric",
                            sorting: true,
                            filtering: true
                        },
                        {
                            title: i18n.get("configurations.mlMin"),
                            field: 'mlMin',
                            hidden: this.default("mlMin"),
                            cellStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            headerStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            filterComponent: helper.RangeFilter,
                            type: "numeric",
                            sorting: true,
                            filtering: true
                        },
                        {
                            title: i18n.get("configurations.msMax"),
                            field: 'msMax',
                            hidden: this.default("msMax"),
                            cellStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            headerStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            filterComponent: helper.RangeFilter,
                            type: "numeric",
                            sorting: true,
                            filtering: true
                        },
                        {
                            title: i18n.get("configurations.msMin"),
                            field: 'msMin',
                            hidden: this.default("msMin"),
                            cellStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            headerStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            filterComponent: helper.RangeFilter,
                            type: "numeric",
                            sorting: true,
                            filtering: true
                        },
                        {
                            title: i18n.get("configurations.sWait"),
                            field: 'sWait',
                            hidden: this.default("sWait"),
                            cellStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            headerStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            filterComponent: helper.RangeFilter,
                            type: "numeric",
                            sorting: true,
                            filtering: true
                        },
                        {
                            title: i18n.get("configurations.sHeartbeat"),
                            field: 'sHeartbeat',
                            hidden: this.default("sHeartbeat"),
                            cellStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            headerStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            filterComponent: helper.RangeFilter,
                            type: "numeric",
                            sorting: true,
                            filtering: true
                        },
                        {
                            title: i18n.get("configurations.mmMax"),
                            field: 'mmMax',
                            hidden: this.default("mmMax"),
                            cellStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            headerStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            filterComponent: helper.RangeFilter,
                            type: "numeric",
                            sorting: true,
                            filtering: true
                        },
                        {
                            title: i18n.get("configurations.msLog"),
                            field: 'msLog',
                            hidden: this.default("msLog"),
                            cellStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            headerStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            filterComponent: helper.RangeFilter,
                            type: "numeric",
                            sorting: true,
                            filtering: true
                        },
                        {
                            title: i18n.get("configurations.ringBuffer"),
                            field: 'ringBuffer',
                            hidden: this.default("ringBuffer"),
                            cellStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            headerStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            filterComponent: helper.RangeFilter,
                            type: "numeric",
                            sorting: true,
                            filtering: true
                        },

                        {
                            title: i18n.get("configurations.endpoints"),
                            field: 'endpoints',
                            hidden: this.default("endpoints"),
                            cellStyle: {
                                minWidth: '300px',
                                maxWidth: '300px',
                            },
                            headerStyle: {
                                minWidth: '300px',
                                maxWidth: '300px',
                            },
                            sorting: false,
                            filtering: false,
                            render: rowData => {
                                return rowData && rowData.endpoints ? rowData.endpoints.map(data => <Chip label={data} style={{ marginRight: 8, marginBottom: 8 }} />) : null
                            }
                        },

                        {
                            title: i18n.get("configurations.threshold"),
                            field: 'threshold',
                            hidden: this.default("threshold"),
                            cellStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            headerStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            filterComponent: helper.RangeFilter,
                            type: "numeric",
                            sorting: true,
                            filtering: true
                        },
                        {
                            title: i18n.get("configurations.created"),
                            field: 'created',
                            hidden: this.default("created"),
                            type: "datetime",
                            cellStyle: {
                                minWidth: '400px',
                                maxWidth: '400px',
                            },
                            headerStyle: {
                                minWidth: '400px',
                                maxWidth: '400px',
                            },
                            filterComponent: helper.DateRangeFilter,
                            sorting: true,
                            filtering: true
                        }

                    ]}
                    data={query =>
                        new Promise(async (resolve, reject) => {

                            try {
                                const where = helper.whereString(query["filters"], this.mapField, ["uuid"]);
                                const orderBy = helper.orderByString(query, this.mapField, "created", query["orderBy"] && query["orderBy"]["field"] === "device");
                                if (query["orderBy"] && query["orderBy"]["field"] === "device" && where === "[]") {
                                    where = '[{column: "created", comparator: GT, datetime: -1}]'
                                }

                                const result = await graphql.clientWithToken(this.props.accessToken).query({
                                    query: gql`
                                    query {
                                        configurations(first: ${query.pageSize}, offset: ${query.pageSize * query.page}, orderBy:${orderBy}, where:${where}) {
                                            totalCount
                                            elements {
                                                ... on Configuration {
                                                    id,
                                                    device {uuid}
                                                    version
                                                    endpoints {address}
                                                    mlMax
                                                    mlMin
                                                    mmMax
                                                    msLog
                                                    msMax
                                                    msMin
                                                    ringBuffer
                                                    sWait
                                                    sHeartbeat
                                                    threshold
                                                    created {X}
                                               }
                                            }
                                        }
                                    }
                                `,
                                    fetchPolicy: "no-cache"
                                });

                                const searchResult = {
                                    page: query.page,
                                    data: result.data.configurations.elements.map(
                                        (element) => {
                                            return {
                                                id: element.id,
                                                device: element.device,
                                                version: element.version,
                                                endpoints: element.endpoints ? element.endpoints.map(endpoint => endpoint.address) : null,
                                                freq: element.freq,
                                                mlMax: element.mlMax,
                                                mlMin: element.mlMin,
                                                mmMax: element.mmMax,
                                                msLog: element.msLog,
                                                msMax: element.msMax,
                                                msMin: element.msMin,
                                                ringBuffer: element.ringBuffer,
                                                sWait: element.sWait,
                                                sHeartbeat: element.sHeartbeat,
                                                threshold: element.threshold,
                                                created: element.created ? moment(element.created.X, 'X').toDate() : null,
                                            };
                                        }),
                                    totalCount: result.data.configurations.totalCount
                                }

                                resolve(searchResult);
                            } catch (error) {
                                this.showMessage(error.message, "error");
                                reject(error);
                            }
                        })
                    }
                    actions={isInRoles(this.props.roles, [ROLE_ADMIN, ROLE_OWNER, ROLE_EDITOR]) ?
                        [{
                            isFreeAction: true,
                            icon: () => { return <ReloadIcon /> },
                            tooltip: i18n.get("general.reload"),
                            onClick: async (event, rowData) => {
                                this.tableRef.current.onQueryChange();
                            }
                        },
                        {
                            isFreeAction: false,
                            icon: TuneIcon,
                            tooltip: i18n.get("configurations.addConfiguration.tooltip"),
                            onClick: async (event, rowData) => {
                                this.setState({
                                    wizard: true,
                                    currentConfiguration: rowData
                                })
                            }
                        }
                        ]
                        :
                        [{
                            isFreeAction: true,
                            icon: () => { return <ReloadIcon /> },
                            tooltip: i18n.get("general.reload"),
                            onClick: async (event, rowData) => {
                                this.tableRef.current.onQueryChange();
                            }
                        }]
                    }
                    title={i18n.get("configurations.title")}
                    options={{
                        addRowPosition: "first",
                        exportButton: false,
                        filtering: true,
                        showTitle: false,
                        debounceInterval: 500,
                        search: false,
                        columnsButton: true,
                        pageSize: this.default("pageSize"),
                        pageSizeOptions: [5, 20, 50]
                    }}
                />

                <ConfigurationWizard
                    open={this.state.wizard}
                    working={this.state.working}
                    data={this.state.currentConfiguration}
                    onCancel={this.handleWizardCancel}
                    accessToken={this.props.accessToken}
                    onSave={this.handleWizardSave} />

                <Message
                    hideAfter={this.state.hideAfter}
                    onClose={this.closeMessage}
                    variant={this.state.variant}
                    message={this.state.message}
                    details={this.state.details}
                    open={this.state.message !== null}
                />
            </div>
        )
    }
}

Configurations.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withIAM(withStyles(styles, { withTheme: true })(Configurations))